import {AfterViewInit, Component, ElementRef, HostListener, NgZone, OnInit, Renderer2, ViewChild} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";
import {fadeAnimation} from "./shared/animations/fade.animation";
import {NavigationService} from "./core/services/navigation.service";
import {Router} from "@angular/router";
import {CartComponent} from "./cart/cart.component";
import {MatBottomSheet, MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {CartService} from "./core/services/cart.service";
import {FormBuilder} from "@angular/forms";
import {LoginComponent} from "./auth/components/login/login.component";
import {MatDialog} from "@angular/material/dialog";
import {SessionLoginService} from "./core/services/session-login.service";
import {Observable, Subscription, BehaviorSubject} from "rxjs";
import {distinctUntilChanged, filter, map, pairwise, share, take, throttleTime} from "rxjs/operators";
import {DialogComponent} from "./cart/components/dialog/dialog.component";
import {MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition} from "@angular/material/snack-bar";
import {MatSidenav, MatSidenavContainer, MatSidenavModule} from "@angular/material/sidenav";
import {getConfService} from "./core/services/getConf.service";
import {TranslateService} from "@ngx-translate/core";
import {TranslationService} from "./products-categories/services/translation.service";
import {LanguageChangeService} from "./products-categories/services/language-change.service";
import {SplashService} from "./splash.service";
import { FirebaseMessagingService} from "./core/services/firebase-messaging.service";
import {FlagsListComponent} from "./core/components/flags-list/flags-list.component";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [fadeAnimation],
})

export class AppComponent implements OnInit, AfterViewInit {
  title = 'menu-app';
  obj!: any
  currentRoute: any;

  @ViewChild('closeright') closeright!: ElementRef;
  @ViewChild('rightSidenav') public sidenav!: MatSidenav;
  @ViewChild('drawercart') public drawercart!: MatSidenav;

  availableLanguages: string[] = [];
  currentLanguage: string = '';

  hasItems: Observable<boolean>;
  subscription!: Subscription;

  options = this._formBuilder.group({
    bottom: 0,
    fixed: true,
    top: 0,
  });

  client = environment.client;
  isBelgium = environment.isBelgium;

  constructor(
    private translationService: TranslationService,
    private translate: TranslateService,
    private http: HttpClient,
    public navigation: NavigationService,
    private  router: Router,
    private bottomSheet: MatBottomSheet,
    private cartService: CartService,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    public session: SessionLoginService,
    public dialogo: MatDialog,
    private _snackBar: MatSnackBar,
    public getConfService: getConfService,
    private languageChangeService: LanguageChangeService,
    private splashService: SplashService,
    private renderer: Renderer2,
    private el: ElementRef,
    public firebaseMessagingService: FirebaseMessagingService
  ) {

    this.hasItems = this.cartService.itemsInCartCount$.pipe(map(result => !!result));

    this.availableLanguages = this.translationService.getAvailableLanguages();

    let lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.translate.use(lang);
      this.currentLanguage = lang;
    }

    this.splashService.showSplash$.subscribe((show: boolean) => {
      this.showSplash = show;
    });


  }

  appName = environment.appName;
  menuUrl = environment.baseUrl;
  menuPdf = environment.menuPdf;
  info = environment.info;

  theme!: string;
  appUrl!: string;
  isIOS: boolean = false;

  async checkIfIOS() {
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
  }

  requestPermission() {
    this.firebaseMessagingService.requestPermission();
  }

  ngOnInit(): void {
    this.checkIfIOS();

    this.firebaseMessagingService.requestPermission();


    localStorage.removeItem('lastId');

    document.title = this.appName;

    this.appUrl = window.location.hostname;
    this.currentRoute = this.router.url;

    let loggedIn = localStorage.getItem('loggedIn');
    let url = environment.baseUrl;
    if (loggedIn == 'true') {
      url = environment.apiUrl
    }

    this.http.get(`${url}/categories/${environment.mainCategory}?lang=` + this.currentLanguage).subscribe(response => {
      this.obj = response;
    });

    this.cartService.updateCountItems();

    this.getConfService.getData();

    this.languageChangeService.currentLanguage$.subscribe((lang) => {
      this.currentLanguage = lang;
      this.translate.use(lang);
      localStorage.setItem('selectedLanguage', lang);

    });



  }

  public lastUpdate!: string

  @ViewChild('sidebar') sidebar!: ElementRef;

  sidebarClickListener: any;

  @ViewChild('sidenavContent', {static: false}) sidenavContent!: ElementRef;

  @ViewChild(MatSidenavContainer) sidenavContainer!: MatSidenavContainer;

  ngAfterViewInit() {
    this.cartService.drawercart = this.drawercart;
  }

  openBottomSheet(): void {
    this.bottomSheet.open(CartComponent);

    setTimeout(() => {
      const drawerContent = document.querySelector('.mat-drawer-content');

      if (drawerContent) {
        this.renderer.listen(drawerContent, 'scroll', (event) => {
          const scrollTop = (event.target as HTMLElement).scrollTop;
          console.log('Scroll position:', scrollTop);
        });
      } else {
        console.warn('.mat-drawer-content introuvable');
      }
    }, 0);
  }

  openBottomSheetLogin(): void {
    this.clickCount = 0;
    this.dialog.open(LoginComponent, {
      data: {
        wrongCreadentials: null
      }
    });
  }

  openLanguageSelector(): void {
    this.clickCount = 0;
    this.dialog.open(FlagsListComponent, {
      data: {
        wrongCreadentials: null
      }
    });
  }

  logOut(): void {
    this.session.logout()
  }

  confirmDialogDeleteAll(): void {
    this.translate.get('YouAreAboutToClearFavorites').subscribe((message: string) => {
      this.dialogo
        .open(DialogComponent, {
          data: message
        })
        .afterClosed()
        .subscribe((confirmDelete: boolean) => {
          if (confirmDelete) {

            this.deleteAll();
          }
        });
    });
  }

  get itemCount(): number {
    return this.cartService.countItems();
  }

  deleteAll() {
    setTimeout(() => {
      this.bottomSheet.dismiss();
      setTimeout(() => {
        this.cartService.clearCart();
        this.openSnackBarDeleteAll();
      }, 500);
    }, 500);

  }

  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';

  openSnackBarDeleteAll() {
    this._snackBar.open("¡Sus favoritos han sido vaciados con éxito!", '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 2000
    });
  }

  changeLanguage(lang: string): void {
    this.languageChangeService.changeLanguage(lang);

    location.reload();
  }

  deferredPrompt: any;
  showInstallButton: boolean = false;
  showSplash = true;

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(event: any) {
    event.preventDefault();
    this.deferredPrompt = event;

    this.showInstallButton = true;

  }

  installPWA() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();

      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('L\'installation de la PWA a été acceptée');

          if (Notification.permission === 'granted') {
            new Notification('L\'application est installée. Ouvrez-la maintenant !');
          }
        } else {
          console.log('L\'installation de la PWA a été refusée');
        }
        this.deferredPrompt = null;
        this.showInstallButton = false;
      });
    }
  }

  clickCount = 0;

  clickTimeout: any;

  onSidebarClick(event: MouseEvent): void {

    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout);
    }

    this.clickCount++;

    this.clickTimeout = setTimeout(() => {
      this.clickCount = 0;
    }, 500);
    console.log(this.clickCount)

    if (this.clickCount >= 3) {

      clearTimeout(this.clickTimeout);
      this.clickCount = 0;

      this.session.isLoggedIn$.pipe(take(1)).subscribe(isLoggedIn => {
        if (isLoggedIn) {
          this.logOut();
        } else {
          this.openBottomSheetLogin();
        }
      });
    }
  }

  isScrolled = false;

  @HostListener('window:scroll', ['$event'])

  myScrollHandler(event: any) {

    const scrollTop = event.target.scrollTop;

    const navbar = this.el.nativeElement.querySelector('.fixednavbar');
    const btn = this.el.nativeElement.querySelector('.home-button');

    if (scrollTop > 0) {
      this.renderer.addClass(navbar, 'fixed');
    } else {
      this.renderer.removeClass(navbar, 'fixed');
    }

    if (scrollTop > 150) {
      this.renderer.addClass(btn, 'fixed');
    } else {
      this.renderer.removeClass(btn, 'fixed');
    }

    this.isScrolled = scrollTop > 100;

    console.log('Scroll position: ', scrollTop);
  }
}
